/**
 * 查找父级组件
 * @param context 上下文
 * @param componentName 组件名
 * @returns {Vue}
 */
function findParentComponent(context, _componentName) {
  let componentName = _componentName;
  if (typeof componentName === 'string') {
    componentName = [componentName];
  }

  let parent = context.$parent;
  let { name } = parent.$options;
  while (parent && (!name || componentName.indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name; // eslint-disable-line
  }
  return parent;
}

// 字节转换
function readablizeBytes(bytes) {
  const s = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const e = Math.floor(Math.log(bytes) / Math.log(1024));
  // eslint-disable-next-line
  return `${(bytes / Math.pow(1024, Math.floor(e))).toFixed(2)} ${s[e]}`;
}

function isType(value, type) {
  return {}.toString.call(value) === `[object ${type}]`;
}

function isEmpty(value) {
  return value === null || value === undefined;
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

const isUndefined = val => val === void 0;

const isDefined = val => val !== undefined && val !== null;

function isFunction(value) {
  return isType(value, 'Function');
}

function isString(value) {
  return isType(value, 'String');
}

function isDate(value) {
  return isType(value, 'Date') && !isNaN(value.getTime());
}

function getValueByPath(obj, _path) {
  let path = _path;
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');
  const keyArr = path.split('.');
  for (let i = 0; i < keyArr.length; i++) {
    const key = keyArr[i];
    tempObj = tempObj[key];
    if (typeof tempObj !== 'object') {
      return tempObj;
    }
  }
  return tempObj;
}

/**
 * 在执行某些操作之前先验证
 * @param {Function | Boolean} validator 验证函数，返回真代表通过验证，也支持返回 promise 处理异步验证
 * @param {String} action 验证通过之后执行的函数
 */
function validateBeforeAction(validator, action) {
  if (typeof validator === 'undefined') {
    action();
    return;
  }
  const result = typeof validator === 'function' ? validator() : validator;
  if (typeof result === 'object' && result.then) {
    result.then(action);
  } else if (result) {
    action();
  }
}

function removeUndefinedAttr(obj) {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] !== 'undefined') {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}

export {
  findParentComponent,
  isEmpty,
  readablizeBytes,
  isType,
  getValueByPath,
  isString,
  isDate,
  isHtmlElement,
  validateBeforeAction,
  isFunction,
  isDefined,
  isUndefined,
  removeUndefinedAttr,
};
